<template>
  <div class="position-relative height-90vh">
    <div class="scrollable-content">
      <div class="row m-0 consultant-container">
        <div class="col-xs-12 mb-15">
          <router-link class="sub-heading" to="/layout/representationresources/producttracker">
            <i class="fa fa-angle-left"></i>Update Product
          </router-link>
        </div>
        <div class="col-xs-12 mt-15 mb-15">
          <div class="heading">
            Provide Project Contact, Product Family, Market related details below :
          </div>
          <div class="note">
            Note: Drop down menu only shows registered users with the role "REP Account Owner" or
            "REP Editor".
            <a @click="openTeams()">Click here </a> if you want to add other contacts.
          </div>
        </div>
        <div class="col-xs-12 mt-15 mb-15">
          <div class="heading mb-15">Please review/update selected country details:</div>
          <div class="col-xs-12 mt-15 mb-15">
            <div class="row m-0">
              <div class="col-xs-12 col-sm-6">
                <div class="row">
                  <div class="form-group col-xs-12">
                    Selected Market:
                    <span v-for="each in selectedCountries" :key="each.id">{{ each.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row mlr-15"
            v-for="(each, index) in producttracker.tracker_markets"
            :key="index"
          >
            <div class="col-xs-12 mb-15">
              <div class="row">
                <div class="col-xs-12 col-sm-6 xs-mb-15">
                  <div class="row">
                    <div class="form-group col-xs-12">
                      Select Project Contacts<span class="required-astreisk">*</span>
                    </div>
                    <div class="col-xs-12">
                      <multiselect
                        :showLabels="false"
                        :close-on-select="false"
                        class="multiselect-single-dropdown multiselect-multiple"
                        :class="!each.tracker_contacts.length ? 'un-selected' : ''"
                        placeholder="Select Contacts"
                        label="first_name"
                        track-by="id"
                        :multiple="true"
                        :searchable="true"
                        :clear-on-select="false"
                        :options="usersList"
                        :value="each.tracker_contacts"
                      >
                        <div
                          class="selection-count"
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                        >
                          <template v-if="!isOpen">
                            <img
                              src="/static/images/icons/filter.svg"
                              alt="filter-icon"
                              class="image-size"
                            /><span class="selected-count">{{ values.length }} Selected</span>
                          </template>
                          <template  v-else-if="isOpen">
                            <img
                              src="/static/images/icons/filter.svg"
                              alt="filter-icon"
                              class="image-size"
                            />
                          </template>
                        </div>
                        <span slot="option" slot-scope="props">
                          <div
                            class="d-flex"
                            @input="selectedContact(props.option.user_id, disableContactNum, each)"
                          >
                            <span class="checkbox inline-checkbox">
                              <label>
                                <input
                                  type="checkbox"
                                  :value="props.option"
                                  :checked="each.tracker_contacts.includes(props.option.user_id)"
                                />
                                <span
                                  class="cr"
                                  :class="{
                                    'disabled-checkbox':
                                      disableContactNum &&
                                      each.tracker_contacts.length == disableContactNum
                                  }"
                                ></span>
                              </label>
                            </span>
                            <div
                            class="text-capitalize"
                            :class="{
                              'font-bold': each.tracker_contacts.includes(props.option.user_id),
                              'font-wt-400': !each.tracker_contacts.includes(props.option.id),
                              'disabled-text':
                                disableContactNum &&
                                !each.tracker_contacts.includes(props.option.user_id) &&
                                each.tracker_contacts.length === disableContactNum
                            }"
                            @click="selectedContact(props.option.user_id, disableContactNum, each)"
                          >
                            {{ props.option.first_name }}
                            {{ props.option.last_name }}
                          </div>
                          </div>
                         
                        </span>
                        <span slot="noResult">No matching data</span>
                      </multiselect>
                    </div>
                  </div>
                  <div v-if="each.tracker_contacts.length" class="row mt-20 col-xs-12 visible-xs">
                    <span
                      class="selected-names text-capitalize"
                      v-for="contact in each.tracker_contacts"
                      :key="contact"
                    >
                      {{ getContact(contact).first_name }}
                      {{ getContact(contact).last_name }}
                      <img
                        src="/static/images/icons/close_blue_icon.svg"
                        class="ml-10 cursor-pointer"
                        @click="selectedContact(contact, disableContactNum, each)"
                      />
                    </span>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 xs-mt-15">
                  <div class="form-group">
                    Add Product Family Name<span class="required-astreisk">*</span>
                  </div>
                  <input
                    type="text"
                    placeholder="Type"
                    class="form-control"
                    v-model.trim="each.family_name"
                    maxlength="100"
                  />
                </div>
                <div v-if="each.tracker_contacts.length" class="mt-20 col-xs-12 hidden-xs">
                  <span
                    class="selected-names text-capitalize"
                    v-for="contact in each.tracker_contacts"
                    :key="contact"
                  >
                    {{ getContact(contact).first_name }}
                    {{ getContact(contact).last_name }}
                    <img
                      src="/static/images/icons/close_blue_icon.svg"
                      class="ml-10 cursor-pointer"
                      @click="selectedContact(contact, disableContactNum, each)"
                    />
                  </span>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mb-15 mt-15">
              <div class="row">
                <div class="col-xs-12 col-sm-6 xs-mb-15">
                  <div class="form-group">
                    GMDN/EMDN<span class="required-astreisk" v-if="each.country_id !== 250">*</span>
                    <span v-else> (Optional)</span>
                  </div>
                  <input
                    type="text"
                    placeholder="Type"
                    class="form-control"
                    v-model.trim="each.gmdn_emdn_cd"
                    maxlength="100"
                  />
                </div>
                <div class="col-xs-12 col-sm-6 xs-mt-15">
                  <div class="form-group">Classification</div>
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    :searchable="false"
                    :options="filterByCountry(classificationList, each.country_id).map((e) => e.id)"
                    :custom-label="
                      (option) =>
                        filterByCountry(classificationList, each.country_id).find(
                          (e) => e.id == option
                        ).name
                    "
                    v-model="each.class_id"
                    @select="checkClassification($event, each)"
                    placeholder="Select Classification"
                  >
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
            </div>
            <div
              class="col-xs-12 mt-15 mb-15"
              v-if="each.country_id !== 14 && each.country_id !== 216"
            >
              <div class="row">
                <div class="col-xs-12 col-sm-6">
                  <div class="form-group">Additional Legislation</div>
                  <multiselect
                    :showLabels="false"
                    :close-on-select="false"
                    class="multiselect-single-dropdown multiselect-multiple"
                    placeholder="Select Directives"
                    :multiple="true"
                    :searchable="true"
                    :clear-on-select="false"
                    :options="filterByCountry(directivesList, each.country_id)"
                    :value="each.directives"
                  >
                    <div class="selection-count" slot="selection" slot-scope="{ isOpen }">
                      <template v-if="!isOpen">
                        <img
                          src="/static/images/icons/filter.svg"
                          alt="filter-icon"
                          class="image-size"
                        /><span class="selected-count">{{ each.directives.length }} Selected</span>
                      </template>
                      <template  v-else-if="isOpen">
                        <img
                          src="/static/images/icons/filter.svg"
                          alt="filter-icon"
                          class="image-size"
                        />
                      </template>
                    </div>
                    <span slot="option" slot-scope="props">
                      <div
                        class="d-flex"
                        @input="updateSelectedDirective(props.option.id, each.directives)"
                      >
                        <span class="checkbox inline-checkbox">
                          <label>
                            <input
                              type="checkbox"
                              :value="props.option"
                              :checked="
                                each.directives && each.directives.includes(props.option.id)
                              "
                            />
                            <span class="cr"></span>
                          </label>
                        </span>
                        <div
                          :class="{
                            'font-bold': each.directives && each.directives.includes(props.option.id),
                            'font-wt-400':
                              !each.directives || each.directives.includes(props.option.id)
                          }"
                          @click="updateSelectedDirective(props.option.id, each.directives)"
                        >
                          {{ props.option.code }}
                        </div>
                      </div>
                    </span>
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
                <div v-if="each.directives && each.directives.length" class="col-xs-12 mt-20">
                  <span
                    class="selected-names"
                    v-for="directive in each.directives"
                    :key="directive"
                  >
                    {{ getDirectiveName(directive, each.country_id) }}
                    <img
                      src="/static/images/icons/close_blue_icon.svg"
                      class="ml-10 cursor-pointer"
                      @click="updateSelectedDirective(directive, each.directives)"
                    />
                  </span>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mt-15">
              <div class="row m-0">
                <div class="col-xs-12 custom-box heading flex-between">
                  <div class="heading">
                    {{ each.trade_names.length }} Trade Name(s)<span class="required-astreisk"
                      >*</span
                    >
                  </div>
                  <div>
                    <a
                      class="cursor-pointer mr-30"
                      @click="checkTradeRemoval(each)"
                      :disabled="
                        selectedTrades[each.country_id] &&
                        selectedTrades[each.country_id].length < 2
                      "
                    >
                      <img
                        src="/static/images/icons/delete_icon.svg"
                        alt
                        class="table-link-img-size"
                      />
                      <span class="table-link-font text-emergo-red hidden-xs"> Remove </span>
                    </a>
                    <a class="cursor-pointer" @click="addTrade(each)">
                      <img
                        src="/static/images/icons/plus_icon_blue.svg"
                        alt
                        class="table-link-img-size"
                      />
                      <span class="table-link-font text-emergo-dark-blue hidden-xs"> Add </span>
                    </a>
                  </div>
                </div>
                <table class="col-xs-12 table trade-table" v-if="each.trade_names.length">
                  <thead>
                    <tr>
                      <th class="wd-30px">
                        <span class="checkbox">
                          <label>
                            <input
                              type="checkbox"
                              v-model="selectAllTrades[each.country_id]"
                              @change="selectAllTradesMethod(each.country_id, each.trade_names)"
                            />
                            <span class="cr"></span>
                          </label>
                        </span>
                      </th>
                      <th>
                        Trade Name
                        <span
                          class="sort sortPosition"
                          @click="sortBy('name')"
                          :class="sortOrders['name'] ? 'asc' : 'desc'"
                          ><img src="/static/images/icons/sortDesc.svg"
                        /></span>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(trade, index) in each.trade_names" :key="index">
                      <td class="wd-30px">
                        <span class="checkbox top-2">
                          <label>
                            <input
                              type="checkbox"
                              v-model="selectedTrades[each.country_id]"
                              :value="trade"
                              @change="
                                updateSelection(each.trade_names, $event, each.country_id, trade)
                              "
                            /> <span class="cr"></span>
                          </label>
                        </span>
                      </td>
                      <td>{{ trade }}</td>
                      <td class="align-right wd-30">
                        <a
                          class="cursor-pointer mr-30"
                          @click="checkTradeRemoval(each, true, index)"
                        >
                          <img
                            src="/static/images/icons/delete_icon.svg"
                            alt
                            class="table-link-img-size"
                          />
                          <span class="table-link-font text-emergo-red hidden-xs"> Remove </span>
                        </a>
                        <a class="cursor-pointer" @click="updateTrade(trade, each, index)">
                          <img
                            src="/static/images/icons/edit_icon.svg"
                            alt
                            class="table-link-img-size"
                          />
                          <span class="table-link-font text-emergo-dark-blue hidden-xs">
                            Update
                          </span>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row col-xs-12 m-0 footer">
      <div
        class="col-xs-4 col-sm-3 col-md-2"
        :class="{
          'col-xs-offset-4 col-md-offset-8 col-sm-offset-6': userData.role_id === 12
        }"
      >
        <router-link
          :to="'/layout/representationresources/producttracker'"
          class="btn btn-block emergo-white-button"
          >Cancel</router-link
        >
      </div>
      <div
        class="col-xs-4 col-sm-offset-3 col-sm-3 col-md-offset-6 col-md-2"
        v-if="userData.role_id === 9 || userData.role_id === 8"
      >
        <button
          class="btn btn-block emergo-white-button"
          :disabled="disableSubmit"
          @click="saveProduct('draft')"
        >
          Save
        </button>
      </div>
      <div class="col-xs-4 col-sm-3 col-md-2">
        <button
          class="btn btn-block emergo-green-button"
          @click="userData.role_id === 12 ? saveProduct('update') : submitPopup()"
          :disabled="disableSubmit"
        >
          {{ userData.role_id === 12 ? 'Update' : 'Submit' }}
        </button>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus === true || loaderStatus === 'page'"></loader>
    <div id="addTradePopup" class="modal fade trade-popup" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <span v-if="tradeIndex !== null && tradeIndex > -1">Update</span>
            <span v-else>Add</span><span> Trade Name</span>
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              @click="closePopupOnOk"
            />
          </div>
          <div class="modal-body generic-body">
            <div class="trade-box">
              <div class="form-group">Trade Name</div>
              <input
                class="form-control"
                :class="{ 'invalid-border': showTradeError }"
                v-model.trim="tradeName"
                maxlength="100"
                placeholder="Trade name"
                @input="showTradeError = ''"
              />
              <div class="custom-error-class pt-5" v-if="showTradeError">
                {{ showTradeError }}
              </div>
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                @click="closePopupOnOk"
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0" v-if="tradeIndex !== null && tradeIndex > -1">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="UpdateTradeModal()"
              >
                Update
              </button>
            </div>
            <div class="col-xs-6 pr-0" v-else>
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="AddTradeModal()"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="removeTradePopup" class="modal fade submit-popup" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="#removeTradePopup"
            />
          </div>
          <div class="modal-body center pt-0">
            <img src="/static/images/icons/expiring_yellow.svg" class="info-icon" />
            <div class="sub-header">Are you sure you would like to delete the Trade Name?</div>
            <div class="sub-text">
              Once deleted, you cannot recover the <br />information again.
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                data-dismiss="modal"
                data-target="#removeTradePopup"
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="submitRemoveTrade()"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="submitPopup" class="modal fade submit-popup" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="#submitPopup"
            />
          </div>
          <div class="modal-body center pt-0">
            <img src="/static/images/icons/expiring_yellow.svg" class="info-icon" />
            <div class="sub-header">Are you sure you want to submit the details?</div>
            <div class="sub-text">
              You cannot directly edit the entries after submission and you will need to “Request
              Modification” to edit submitted entries. Only “Draft” entries can be directly edited
              again.
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-6 pl-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                data-dismiss="modal"
                data-target="#submitPopup"
              >
                Cancel
              </button>
            </div>
            <div class="col-xs-6 pr-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="saveProduct()"
              >
                Submit
              </button>
            </div>
          </div>
          <loader :loadingStatus="loaderStatus === 'modal'"></loader>
        </div>
      </div>
    </div>
    <div id="submitErrorPopup" class="modal fade submit-popup" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header generic-header">
            <img
              class="close-icon cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              data-dismiss="modal"
              data-target="#submitErrorPopup"
            />
          </div>
          <div class="modal-body center pt-0">
            <img src="/static/images/icons/alert_triangle.svg" class="info-icon" />
            <div class="sub-header">
              You cannot proceed further as you did not fill the mandatory details
            </div>
            <div class="sub-text">
              Kindly provide the “GMDN/EMDN” details and atleast one ”Trade Name” for the required
              countries to submit the product request.
            </div>
          </div>
          <div class="modal-footer" style="clear: both">
            <div class="col-xs-offset-3 col-xs-6">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                data-dismiss="modal"
                data-target="#submitErrorPopup"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Classification-Confirmation-Popup
      @closeConfirmationPopup="closeClassificationConfirmationPopup"
      :popupData="classificationPopupData"
      :title="classificationTitle"
    />
  </div>
</template>
<script>
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import EventBus from '../../../utils/event-bus';
import { getUserData } from '../../../apis/profile';
import { getTeamMembers } from '../../../apis/team';
import Loader from '../../UIComponents/Loader.vue';
import permissionsList from '../../UIComponents/mixins/rbacPermissionsMixin';
import {
  getProductTrackerMetaData,
  getProductTrackerById,
  getProductTrackerByCountryId,
  updateProductTrackerByCountryId
} from '../../../apis/productTracker';
import ClassificationConfirmationPopup from './ClassificationConfirmationPopup.vue';
import { getSasToken } from '../../../apis/regsAndGuidance';
import getJSONresponse from '../../../apis/responseJSON';

const countryobj = {
  class_id: null,
  country_id: 0,
  directives: [],
  trade_names: [],
  gmdn_emdn_cd: '',
  workflow_status_id: 0,
  tracker_contacts: []
};
export default {
  mixins: [permissionsList],
  data() {
    return {
      usersList: [],
      selectedCountries: [],
      loaderStatus: false,
      producttracker: {
        account_id: 0,
        tracker_markets: []
      },
      isContactInvalid: false,
      isCountryInvalid: false,
      directivesList: [],
      classificationList: [],
      sortOrders: {
        name: true
      },
      tradeName: '',
      tradeIndex: null,
      selectedmarketObj: null,
      selectedTrades: {},
      selectAllTrades: {},
      userData: null,
      metaData: {},
      countriesList: [],
      productId: null,
      showTradeError: '',
      disableContactNum: 0,
      selectedCountryId: null,
      selectedMarketId: null,
      classificationTitle: '',
      classificationPopupJSON: [],
      classificationPopupData: {}
    };
  },
  components: {
    Loader,
    ClassificationConfirmationPopup
  },
  computed: {
    disableSubmit() {
      return this.producttracker.tracker_markets.some(
        (e) => !e.family_name || !e.tracker_contacts.length
      );
    }
  },
  methods: {
    checkClassification(value, each) {
      this.selectedmarketId = each.country_id;
      const selectedClassification = this.classificationList.find((e) => e.id === value);
      if (selectedClassification && selectedClassification.tool_tip_key) {
        this.classificationTitle = selectedClassification.name;
        const data = this.classificationPopupJSON.find(
          (e) => e.type === selectedClassification.tool_tip_key
        );
        if (data) {
          this.classificationPopupData = data;
          $('#classificationConfirmationPopup').modal({
            backdrop: 'static',
            keyboard: false
          });
        }
      }
    },
    closeClassificationConfirmationPopup(response) {
      if (!response) {
        const index = this.producttracker.tracker_markets.findIndex(
          (e) => e.country_id === this.selectedmarketId
        );
        if (index > -1) this.producttracker.tracker_markets[index].class_id = '';
      }
      // this.classificationPopupData = {};
      // this.classificationTitle = '';
    },
    selectAllTradesMethod(countryId, trades) {
      const selectedTrades = { ...this.selectedTrades };
      selectedTrades[countryId] = [];
      if (this.selectAllTrades[countryId]) {
        trades.forEach((trade) => {
          selectedTrades[countryId].push(trade);
        });
      }
      this.$set(this, 'selectedTrades', selectedTrades);
    },
    updateSelection(data, event, countryId, selectedTrade) {
      const selectedTrades = { ...this.selectedTrades };
      if (!event.target.checked) {
        this.selectAllTrades[countryId] = false;
        const i = selectedTrades[countryId].findIndex((file) => file === selectedTrade);
        if (i > -1) selectedTrades[countryId].splice(i, 1);
      } else if (event.target.checked) {
        if (selectedTrades[countryId].findIndex((file) => file === selectedTrade) === -1) {
          selectedTrades[countryId].push(selectedTrade);
        }
        if (selectedTrades[countryId].length === data.length) {
          this.selectAllTrades[countryId] = true;
        }
      }
      this.$set(this, 'selectedTrades', selectedTrades);
    },
    openTeams() {
      EventBus.$emit('openAccountSettingsPopup', 'team');
    },
    getCountryName(id) {
      return this.countriesList.find((c) => c.country_id === id)?.name || '';
    },
    getDirectiveName(id, countryId) {
      return this.directivesList.find((c) => c.id === id && c.country_id === countryId)?.code || '';
    },
    closePopupOnOk() {
      $('#addTradePopup').modal('hide');
      this.tradeName = '';
      this.tradeIndex = null;
      this.selectedmarketObj = null;
      this.showTradeError = '';
    },
    AddTradeModal() {
      if (
        this.tradeName &&
        this.selectedmarketObj.trade_names.find(
          (element) => element.toLowerCase() === this.tradeName.toLowerCase()
        )
      ) {
        this.showTradeError = 'Trade name already exists.';
      } else if (this.tradeName) {
        this.selectedmarketObj.trade_names.push(this.tradeName);
        this.selectAllTradesMethod(
          this.selectedmarketObj.country_id,
          this.selectedmarketObj.trade_names
        );
        this.closePopupOnOk();
      }
      // this.$notify({
      //   type: 'success',
      //   title: 'Success',
      //   text: 'Trade name added successfully. Please submit the product.',
      //   group: 'custom-notification',
      // });
    },
    UpdateTradeModal() {
      if (
        this.tradeName &&
        this.selectedmarketObj.trade_names.find(
          (element, index) =>
            index !== this.tradeIndex && element.toLowerCase() === this.tradeName.toLowerCase()
        )
      ) {
        this.showTradeError = 'Trade name already exists.';
      } else if (this.tradeName) {
        this.selectedmarketObj.trade_names[this.tradeIndex] = this.tradeName;
        this.closePopupOnOk();
      }
      // this.$notify({
      //   type: 'success',
      //   title: 'Success',
      //   text: 'Trade name updated successfully. Please submit the product.',
      //   group: 'custom-notification',
      // });
    },
    updateTrade(trade, obj, index) {
      this.tradeName = trade;
      this.tradeIndex = index;
      this.selectedmarketObj = obj;
      $('#addTradePopup').modal('show');
    },
    addTrade(obj) {
      this.selectedmarketObj = obj;
      $('#addTradePopup').modal('show');
    },
    checkTradeRemoval(obj, single = false, index) {
      if (single) this.tradeIndex = index;
      this.selectedmarketObj = obj;
      $('#removeTradePopup').modal('show');
    },
    submitRemoveTrade() {
      const selectedTrades = { ...this.selectedTrades };
      if (this.tradeIndex !== null && this.tradeIndex > -1) {
        this.selectedmarketObj.trade_names.splice(this.tradeIndex, 1);
      } else {
        selectedTrades[this.selectedmarketObj.country_id].forEach((trade) => {
          const index = this.selectedmarketObj.trade_names.findIndex((i) => i === trade);
          if (index > -1) this.selectedmarketObj.trade_names.splice(index, 1);
        });
        selectedTrades[this.selectedmarketObj.country_id] = [];
        this.$set(this, 'selectedTrades', selectedTrades);
        if (this.selectAllTrades[this.selectedmarketObj.country_id])
          this.selectAllTrades[this.selectedmarketObj.country_id] = false;
      }
      $('#removeTradePopup').modal('hide');
      // this.$notify({
      //   type: 'success',
      //   title: 'Success',
      //   text: 'Trade name(s) removed successfully. Please submit the product.',
      //   group: 'custom-notification',
      // });
      this.tradeName = '';
      this.tradeIndex = null;
      this.selectedmarketObj = null;
      this.showTradeError = '';
    },
    sortBy(field) {
      this.sortOrders[field] = !this.sortOrders[field];
      this.trade_names.sort((item1, item2) => {
        const x = item1.toLowerCase();
        const y = item2.toLowerCase();
        if (x < y) {
          return this.sortOrders[field] ? -1 : 1;
        }
        if (x > y) {
          return this.sortOrders[field] ? 1 : -1;
        }
        return 0;
      });
    },
    selectedContact(item, limit = 0, each) {
      if (each.tracker_contacts.findIndex((c) => item === c) === -1) {
        each.tracker_contacts.push(item);
        if (limit && each.tracker_contacts.length > limit) {
          this.$nextTick(() => {
            each.tracker_contacts.splice(limit, each.tracker_contacts.length);
          });
        }
      } else {
        each.tracker_contacts = each.tracker_contacts.filter((c) => item !== c);
      }
    },
    getContact(id) {
      return this.usersList.find((f) => f.user_id === id) || {};
    },
    selectedItem(item, key, matchkey, limit = 0) {
      if (
        this[key].findIndex((c) => {
          if (typeof c === 'object') {
            return c[matchkey] === item[matchkey];
          }
          return item === c;
        }) === -1
      ) {
        this[key].push(item);
        if (limit && this[key].length > limit) {
          this.$nextTick(() => {
            this[key].splice(limit, this[key].length);
          });
        }
        if (key === 'selectedCountries') {
          if (!this.selectedTrades[item[matchkey]]) {
            this.selectedTrades[item[matchkey]] = [];
            this.selectAllTrades[item[matchkey]] = false;
          }
          this.producttracker.tracker_markets.push(
            cloneDeep({ ...countryobj, ...{ country_id: item[matchkey] } })
          );
          setTimeout(() => {
            $(`#collapse_country_${item[matchkey]}`).collapse('show');
          }, 50);
        }
      } else {
        this[key] = this[key].filter((c) => {
          if (typeof c === 'object') {
            return c[matchkey] !== item[matchkey];
          }
          return item !== c;
        });
        if (key === 'selectedCountries') {
          delete this.selectedTrades[item[matchkey]];
          delete this.selectAllTrades[item[matchkey]];
          const index = this.producttracker.tracker_markets.findIndex(
            (e) => e.country_id === item[matchkey]
          );
          if (index > -1) {
            this.producttracker.tracker_markets.splice(index, 1);
          }
        }
      }
    },
    updateSelectedDirective(option, directives) {
      const index = directives.findIndex((c) => c === option);
      if (index === -1) {
        directives.push(option);
      } else {
        directives = directives.splice(index, 1);
      }
    },
    async getTeamMembers() {
      const usersList = await getTeamMembers(
        this.userData.account_type_id === 2 || this.userData.account_type_id === 4 ? 1 : 0
      );
      this.usersList = usersList.filter(
        (user) => (user.role_id === 9 || user.role_id === 8) && !user.is_restricted
      );
    },
    submitPopup() {
      let checkGmdnInput = false;
      this.producttracker.tracker_markets.forEach((i) => {
        if ((i.country_id !== 250 && !i.gmdn_emdn_cd) || i.trade_names.length < 1) {
          checkGmdnInput = true;
        }
      });
      if (checkGmdnInput) {
        $('#submitErrorPopup').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        $('#submitPopup').modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    },
    filterByCountry(data, countryId) {
      return data.filter((c) => c.country_id === countryId) || [];
    },
    async getMetaData() {
      let metaData = {};
      if (this.$route.params.metaData) {
        metaData = this.$route.params.metaData;
      } else {
        metaData = await getProductTrackerMetaData();
      }
      ({
        product_tracker_countries: this.countriesList = [],
        directive: this.directivesList = [],
        classes: this.classificationList = []
      } = metaData);
    },
    async saveProduct(key = 'submit') {
      this.producttracker.account_id = this.userData.account_id;
      this.producttracker.user_id = this.userData.id;
      this.producttracker.tracker_markets.forEach((e) => {
        if (key === 'draft' && !e.workflow_status_id) e.workflow_status_id = 1;
        else if (key === 'submit' && (!e.workflow_status_id || e.workflow_status_id <= 2))
          e.workflow_status_id = 2;
        else if (key === 'update' && (!e.workflow_status_id || e.workflow_status_id <= 2))
          e.workflow_status_id = 2;
      });
      if (this.userData.role_id === 12) {
        let checkGmdnInput = false;
        this.producttracker.tracker_markets.forEach((i) => {
          if ((i.country_id !== 250 && !i.gmdn_emdn_cd) || i.trade_names.length < 1) {
            checkGmdnInput = true;
          }
        });
        if (checkGmdnInput) {
          $('#submitErrorPopup').modal({
            backdrop: 'static',
            keyboard: false
          });
          return;
        }
      }
      this.loaderStatus = key === 'submit' ? 'modal' : 'page';
      const response = await updateProductTrackerByCountryId(
        this.producttracker,
        this.productId,
        this.selectedCountryId
      );
      this.loaderStatus = '';
      if (response && response.status_code === 200) {
        $('#submitPopup').modal('hide');
        sessionStorage.removeItem('selectedProductTrackerDetails');
        this.$router.push('/layout/representationresources/producttracker');
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'success',
          title: 'Success',
          text:
            // eslint-disable-next-line no-nested-ternary
            key === 'update'
              ? 'Product updated successfully.'
              : key === 'submit'
              ? 'Product request submitted successfully.'
              : 'Product saved successfully.',
          group: 'custom-notification'
        });
      } else if (response && response.status_code === 403) {
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Product family name already exists.',
          group: 'custom-notification'
        });
      } else {
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'error',
          title: 'Error',
          text:
            // eslint-disable-next-line no-nested-ternary
            key === 'update'
              ? 'unable to update product.'
              : key === 'submit'
              ? 'Unable to submit the product request.'
              : 'Unable to save the product.',
          group: 'custom-notification'
        });
      }
    },
    async getProductDetails() {
      const producttracker = await getProductTrackerById(this.productId);
      this.selectedCountries = producttracker.tracker_markets.map((e) =>
        this.countriesList.find((c) => c.country_id === e.country_id)
      );
      this.selectedCountries.forEach((c) => {
        if (!this.selectedTrades[c.country_id]) {
          this.selectedTrades[c.country_id] = [];
          this.selectAllTrades[c.country_id] = false;
        }
      });
      this.producttracker = producttracker;
      setTimeout(() => {
        $('.collapse').collapse('show');
      }, 50);
    },
    async getProductDetailsByCountryId() {
      const producttracker = await getProductTrackerByCountryId(
        this.productId,
        this.selectedCountryId
      );
      this.selectedCountries = producttracker.tracker_markets.map((e) =>
        this.countriesList.find((c) => c.country_id === e.country_id)
      );
      this.selectedCountries.forEach((c) => {
        if (!this.selectedTrades[c.country_id]) {
          this.selectedTrades[c.country_id] = [];
          this.selectAllTrades[c.country_id] = false;
        }
      });
      this.producttracker = producttracker;
      setTimeout(() => {
        $('.collapse').collapse('show');
      }, 50);
    },
    async validateFeatures() {
      this.loaderStatus = true;
      const servicesList = ['REPRESENTATION_RESOURCES'];
      const modulesList = ['REPRESENTATION_RESOURCES_PRODUCT_TRACKER'];
      const permissions = await this.permissionsList(servicesList, modulesList);
      this.loaderStatus = false;
      return permissions;
    },
    async getClassificationPopupJSON() {
      const token = await getSasToken({
        container_name: 'prodtracker',
        file_name: '',
        folder_name: 'template',
        permissions: 'read',
        storage_name: 'rams-storage-java'
      });
      this.classificationPopupJSON = await getJSONresponse(
        `${process.env.VUE_APP_AZURE_BLOB_URL}/prodtracker/template/ClassificationPopupData.json?${token.data}`
      );
    }
  },
  async created() {
    const selectedProductTrackerDetails = sessionStorage.getItem('selectedProductTrackerDetails')
      ? JSON.parse(sessionStorage.getItem('selectedProductTrackerDetails'))
      : {};
    this.productId = selectedProductTrackerDetails.id;
    this.selectedCountryId = selectedProductTrackerDetails.countryId;
    this.userData = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : await getUserData();
    const permissions = this.$route.params.permissions
      ? this.$route.params.permissions
      : await this.validateFeatures();
    if (
      !this.productId ||
      (!permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_PRODUCT') &&
        !permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_DRAFT'))
    ) {
      if (permissions.includes('REPRESENTATION_RESOURCES_PRODUCT_TRACKER'))
        this.$router.push('/layout/representationresources/producttracker');
      else this.$router.push('/layout/dashboard');
      return;
    }
    countryobj.user_id = this.userData.id;
    this.loaderStatus = true;
    await Promise.all([
      this.getTeamMembers(),
      this.getMetaData(),
      this.getClassificationPopupJSON()
    ]);
    // await this.getProductDetails();
    await this.getProductDetailsByCountryId();
    this.loaderStatus = false;
  }
};
</script>
<style scoped>
.height-90vh {
  min-height: calc(100vh - 80px);
}
.mr-30 {
  margin-right: 30px;
}
.footer {
  padding-top: 25px;
  position: absolute;
  padding-bottom: 25px;
  background-color: #fff;
  bottom: 0;
  border-top: 1px solid #bdbdbd;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mlr-15 {
  margin: 0 15px;
}
.vertical-line {
  margin: 20px 0;
  border: 0.5px solid #bdbdbd;
}
.border-top {
  border-top: 1px solid;
}
.consultant-container {
  padding: 25px 15px 0;
}
.scrollable-content {
  height: calc(100vh - 166px);
  overflow-y: scroll;
  padding-bottom: 30px;
}
.custom-box {
  padding: 20px 25px;
  border-top: 1px solid #bdbdbd;
}
.sub-heading > i {
  margin-right: 15px;
  font-size: 24px;
}
.sub-heading {
  font-family: Roboto;
  font-style: normal;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
  cursor: pointer;
}
.heading {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  color: rgba(0, 0, 0, 0.7);
}
.note {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  padding-top: 15px;
  color: rgba(0, 0, 0, 0.7);
}
.note a {
  font-size: 16px;
  cursor: pointer;
  margin: 0 5px;
}
.required-astreisk {
  color: #b00505;
  margin-left: 5px;
}
.selected-names {
  background: rgba(201, 226, 244, 0.5);
  border-radius: 28px;
  padding: 8px 15px 8px 17px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #0b3c61;
  margin-right: 10px;
  margin-bottom: 20px;
  display: inline-block;
}
.country-accordian .panel {
  border-bottom: 1px solid #bdbdbd;
  border-radius: 0;
}
.country-accordian .panel:last-child {
  border: 0;
  border-radius: 0;
  box-shadow: none;
}
.country-accordian.panel-group .panel-heading + .panel-collapse > .panel-body {
  border-top: none;
  padding: 15px 0;
}
.country-accordian .panel-heading {
  padding: 15px 0 15px;
  cursor: pointer;
}
.country-accordian .panel-title .header {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-between;
}
.country-accordian .panel-title .header[aria-expanded='true'] img {
  -ms-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.table-link-img-size {
  width: 18px;
  height: 18px;
  vertical-align: top;
  margin: 2px 2px 0 0;
}
.table-link-font {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
}
.trade-table {
  vertical-align: unset;
}
.trade-table tr:hover > td {
  background-color: #fff;
}
.trade-table tr:last-child {
  border-bottom: 0 !important;
}
.trade-table tr {
  border-bottom: 1px solid #bdbdbd;
}
.trade-table thead tr {
  border-top: 1px solid #bdbdbd;
}
.trade-table tr th,
.trade-table tr td {
  vertical-align: middle;
}
.trade-table tr > td {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
  padding: 17px 20px 17px 25px !important;
}
.trade-table td a {
  color: #0b3c61;
}
.trade-table th {
  font-weight: 500;
  font-size: 14px;
  color: #0b3c61;
  line-height: 16px;
  padding: 17px 20px 17px 25px !important;
  border: none;
}
.trade-table thead {
  background: #fff;
  border-bottom: 1px dashed #bdbdbd !important;
}
.trade-table.table > thead:first-child > tr:first-child > th {
  font-weight: 500;
}
.trade-table .cell {
  word-break: break-word;
}
.sort {
  padding-left: 8px;
}
.sort.asc img {
  /* content: url("/static/images/icons/sortDesc.svg"); */
  -ms-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.sortPosition img {
  position: relative;
  top: -1px;
  /* right: 4px; */
}
.modal-content {
  border-radius: 10px;
}
.modal-header {
  padding: 25px 25px 0;
  background: #fff;
  border-radius: 10px;
  border: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.modal-footer {
  background: #fff;
  border-radius: 10px;
  border: 0;
  padding: 30px 35px;
}
.modal-body {
  padding: 15px 35px;
}
.close-icon {
  position: absolute;
  top: 18px;
  right: 18px;
}
.modal-dialog .form-control.text-box {
  height: 150px;
  resize: none;
}
.info-icon {
  width: 58px;
  height: 58px;
}
.modal-body .sub-header {
  color: rgba(0, 0, 0, 0.7);
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  padding-top: 25px;
  padding-bottom: 20px;
}
.modal-body .sub-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  padding-top: 10px;
  padding-bottom: 10px;
}
.submit-popup .modal-header {
  padding: 25px;
}
.submit-popup .modal-body {
  width: 92%;
  margin: auto;
}
.submit-popup .modal-footer {
  width: 90%;
  margin: auto;
  padding: 30px 15px;
}
.submit-popup .modal-dialog {
  width: 480px;
}
.pt-0 {
  padding-top: 0;
}
.wd-30px {
  width: 30px;
}
.trade-popup .modal-dialog {
  width: 500px;
}
.trade-popup .modal-body {
  padding: 35px 25px 15px;
  height: 150px;
}
.trade-popup .modal-footer {
  padding: 30px 25px;
}
/* .trade-box {
  display: flex;
}
.trade-box .input-label {
  margin: 8px 20px 0 0;
  font-size: 16px;
}
.trade-box .input-box {
  width: 75%;
} */
@media screen and (max-width: 767px) {
  .trade-popup .modal-dialog,
  .submit-popup .modal-dialog {
    width: auto;
  }
  .xs-mt-15 {
    margin-top: 15px;
  }
  .xs-mb-15 {
    margin-bottom: 15px;
  }
  .mr-30 {
    margin-right: 15px;
  }
  .trade-table tr > th,
  .trade-table tr > td {
    padding: 17px 10px !important;
  }
  .custom-box {
    padding: 20px 10px;
  }
  .wd-30 {
    width: 30%;
  }
  .wd-30px {
    width: auto;
  }
  .trade-box {
    display: block;
  }
  .trade-box .input-label {
    margin: 0 0 10px;
  }
  .trade-box .input-box {
    width: 100%;
  }
  .consultant-container {
    padding: 25px 0 0;
  }
}
</style>
